
import React from "react"
import { Map, TileLayer, Marker, Popup } from "react-leaflet"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import ImgMap from "../images/map.svg"
import ImgPhone from "../images/phone.svg"
import ImgMail from "../images/mail.svg"
import HeadImage from "../components/headImage"

import yaml from "../data/pages/contact.data.yml"

class MyMap extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      lat: props.lat,
      long: props.long,
      zoom: "7",
      location: props.location
    }
  }

  render() {
    const position = [this.state.lat, this.state.long]
    if (typeof window !== 'undefined') {
      return (
        <Map center={position} zoom={this.state.zoom} style={{height: "490px", zIndex: 10}}>
          <TileLayer
            attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={position}>
            <Popup>
              {this.state.location}
            </Popup>
          </Marker>
        </Map>
      )
    }
    return null
  }
}

const Contact = ({ data }) => {
  const metadata = data.dataJson
  return (
    <Layout>
      <SEO title={yaml.title} description={yaml.desc}/>
      
      <HeadImage fluid={data.file.childImageSharp.fluid} />
      <h2 className="mb-4 mt-8">{yaml.title}</h2>
        <div className="flex"><img className="mr-2 min-w-6" src={ImgMap} alt="Carte"/><span>{metadata.location}</span></div>
        <div className="flex"><img className="mr-2 min-w-6" src={ImgPhone} alt="Téléphone"/><a href={`tel:${metadata.phone}`}>{metadata.phone}</a></div>
        <div className="flex mb-4"><img className="mr-2 min-w-6" src={ImgMail} alt="Adresse e-mail"/><a href={`mailto: ${metadata.email}`}>{metadata.email}</a></div>

        <MyMap lat={metadata.latitude} long={metadata.longitude} location={metadata.location} />
    </Layout>
  )
}

export default Contact

export const pageQuery = graphql`
  query {
    dataJson {
      email
      phone
      longitude
      latitude
      location
    }
    file(relativePath: {eq: "headImage-5.png"}) {
      childImageSharp {
        fluid(quality:90, maxWidth: 1280) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`